import React from 'react';
import classNames from 'classnames';

import type { IRelatedForResort } from 'api/region/types';
import { RegionRelated } from 'components/resort/ResortRelated/Related';
import { ResortNearby } from 'components/resort/ResortRelated/Nearby';

import styles from './styles.module.scss';

interface IProps {
  className?: string,
  related: IRelatedForResort | undefined,
}

export const RelatedHeader = ({
  className,
  related,
}: IProps) => {
  if (!related) {
    return null;
  }

  return (
    <div className={classNames(styles.related, className)}>
      {!!related.related?.length && <RegionRelated links={related.related} />}
      {!!related.nearby?.length && <ResortNearby links={related.nearby} />}
    </div>
  );
};
